var _path, _path2, _g, _path3, _g2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAlfredoIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "79 0 1000 1000",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M79 300C79 134.315 213.315 0 379 0H779C944.685 0 1079 134.315 1079 300V700C1079 865.685 944.685 1000 779 1000H379C213.315 1000 79 865.685 79 700V300Z",
    fill: "#4E9AE2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M995.838 500.982C995.838 730.389 808.793 916.359 578.062 916.359C347.331 916.359 160.287 730.389 160.287 500.982C160.287 271.575 347.331 85.6047 578.062 85.6047C808.793 85.6047 995.838 271.575 995.838 500.982Z",
    fill: "url(#alfredooperacoes-paint0_radial_ledope)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alfredooperacoes-filter1_dddddd_ledope)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 389.723,
    cy: 431.882,
    rx: 133.981,
    ry: 96.723,
    transform: "rotate(-90 389.723 431.882)",
    fill: "#C9D4DA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.723 302.901C414.422 302.901 437.234 316.759 454.062 340.07C470.886 363.373 481.446 395.818 481.446 431.882C481.446 467.946 470.886 500.39 454.062 523.694C437.234 547.004 414.422 560.862 389.723 560.862C365.024 560.862 342.212 547.004 325.383 523.694C308.56 500.39 298 467.946 298 431.882C298 395.818 308.56 363.373 325.383 340.07C342.212 316.759 365.024 302.901 389.723 302.901Z",
    stroke: "#FFFFFF",
    strokeWidth: 10
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#alfredooperacoes-filter2_dddddd_ledope)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "alfredooperacoes-path-5-inside-1_ledope",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M767.723 297.901C714.304 297.901 671 357.886 671 431.882C671 505.877 714.304 565.862 767.723 565.862C821.141 565.862 864.446 505.877 864.446 431.882C864.446 357.886 821.141 297.901 767.723 297.901Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M767.723 297.901C714.304 297.901 671 357.886 671 431.882C671 505.877 714.304 565.862 767.723 565.862C821.141 565.862 864.446 505.877 864.446 431.882C864.446 357.886 821.141 297.901 767.723 297.901Z",
    fill: "#C9D4DA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M767.723 297.901C714.304 297.901 671 357.886 671 431.882C671 505.877 714.304 565.862 767.723 565.862C821.141 565.862 864.446 505.877 864.446 431.882C864.446 357.886 821.141 297.901 767.723 297.901Z",
    stroke: "#FFFFFF",
    strokeWidth: 20,
    mask: "url(#alfredooperacoes-path-5-inside-1_ledope)"
  })))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M490.159 902.74C175.417 509.449 388.078 234.853 517.57 85.6047L439.12 104.267L375.791 134.111L328.531 163.027C246.299 220.861 212.272 294.553 185.807 350.521L169.739 405.556L161.232 460.592L160.287 500.709L161.232 541.745L169.739 585.587L180.136 626.631L192.423 656.48C228.341 736.701 254.88 758.131 277.491 783.341C309.627 816.922 329.476 835.578 393.749 868.227L419.27 880.353L452.351 892.479L490.159 902.74Z",
    fill: "white",
    fillOpacity: 0.15
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#alfredooperacoes-filter3_dddddd_ledope)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M469.839 612.928C531.193 579.675 567.26 609.282 577.624 628.241C605.814 584.488 661.63 597.872 686.301 611.415C716.953 628.241 735.935 630.429 767.383 628.241C716.825 714.01 696.561 720.747 675.045 726.686C633.567 738.135 594.206 720.853 577.624 704.81C534.51 741.563 491.948 734.708 476.057 726.686C419.677 698.684 394.527 650.847 389 630.429C412.215 635.679 453.602 621.728 469.839 612.928Z",
    fill: "#C9D4DA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M469.839 612.928C531.193 579.675 567.26 609.282 577.624 628.241C605.814 584.488 661.63 597.872 686.301 611.415C716.953 628.241 735.935 630.429 767.383 628.241C716.825 714.01 696.561 720.747 675.045 726.686C633.567 738.135 594.206 720.853 577.624 704.81C534.51 741.563 491.948 734.708 476.057 726.686C419.677 698.684 394.527 650.847 389 630.429C412.215 635.679 453.602 621.728 469.839 612.928Z",
    stroke: "#FFFFFF",
    strokeWidth: 10
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "alfredooperacoes-filter0_d_ledope",
    x: 289,
    y: 297.901,
    width: 579.446,
    height: 275.961,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_ledope"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_ledope",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "alfredooperacoes-filter1_dddddd_ledope",
    x: 22.8951,
    y: 27.7962,
    width: 733.656,
    height: 808.171,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.21553
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.788235 0 0 0 0 0.831373 0 0 0 0 0.854902 0 0 0 0.45 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_ledope"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6.43107
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.788235 0 0 0 0 0.831373 0 0 0 0 0.854902 0 0 0 0.22 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_ledope",
    result: "effect2_dropShadow_ledope"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 22.5087
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.788235 0 0 0 0 0.831373 0 0 0 0 0.854902 0 0 0 0.08 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect2_dropShadow_ledope",
    result: "effect3_dropShadow_ledope"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 45.0175
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.788235 0 0 0 0 0.831373 0 0 0 0 0.854902 0 0 0 0 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect3_dropShadow_ledope",
    result: "effect4_dropShadow_ledope"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 77.1728
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.788235 0 0 0 0 0.831373 0 0 0 0 0.854902 0 0 0 0 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect4_dropShadow_ledope",
    result: "effect5_dropShadow_ledope"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 135.052
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.788235 0 0 0 0 0.831373 0 0 0 0 0.854902 0 0 0 0 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect5_dropShadow_ledope",
    result: "effect6_dropShadow_ledope"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect6_dropShadow_ledope",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "alfredooperacoes-filter2_dddddd_ledope",
    x: 400.895,
    y: 27.7962,
    width: 733.656,
    height: 808.171,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.21553
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.788235 0 0 0 0 0.831373 0 0 0 0 0.854902 0 0 0 0.45 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_ledope"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6.43107
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.788235 0 0 0 0 0.831373 0 0 0 0 0.854902 0 0 0 0.22 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_ledope",
    result: "effect2_dropShadow_ledope"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 22.5087
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.788235 0 0 0 0 0.831373 0 0 0 0 0.854902 0 0 0 0.08 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect2_dropShadow_ledope",
    result: "effect3_dropShadow_ledope"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 45.0175
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.788235 0 0 0 0 0.831373 0 0 0 0 0.854902 0 0 0 0 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect3_dropShadow_ledope",
    result: "effect4_dropShadow_ledope"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 77.1728
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.788235 0 0 0 0 0.831373 0 0 0 0 0.854902 0 0 0 0 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect4_dropShadow_ledope",
    result: "effect5_dropShadow_ledope"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 135.052
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.788235 0 0 0 0 0.831373 0 0 0 0 0.854902 0 0 0 0 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect5_dropShadow_ledope",
    result: "effect6_dropShadow_ledope"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect6_dropShadow_ledope",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "alfredooperacoes-filter3_dddddd_ledope",
    x: 0.593719,
    y: 211.49,
    width: 1157.33,
    height: 907.958,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.5406
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.788235 0 0 0 0 0.831373 0 0 0 0 0.854902 0 0 0 0.45 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_ledope"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 9.08119
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.788235 0 0 0 0 0.831373 0 0 0 0 0.854902 0 0 0 0.22 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_ledope",
    result: "effect2_dropShadow_ledope"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 31.7842
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.788235 0 0 0 0 0.831373 0 0 0 0 0.854902 0 0 0 0.08 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect2_dropShadow_ledope",
    result: "effect3_dropShadow_ledope"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 63.5683
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.788235 0 0 0 0 0.831373 0 0 0 0 0.854902 0 0 0 0 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect3_dropShadow_ledope",
    result: "effect4_dropShadow_ledope"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 108.974
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.788235 0 0 0 0 0.831373 0 0 0 0 0.854902 0 0 0 0 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect4_dropShadow_ledope",
    result: "effect5_dropShadow_ledope"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 190.705
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.788235 0 0 0 0 0.831373 0 0 0 0 0.854902 0 0 0 0 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect5_dropShadow_ledope",
    result: "effect6_dropShadow_ledope"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect6_dropShadow_ledope",
    result: "shape"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "alfredooperacoes-paint0_radial_ledope",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(578.062 500.982) rotate(90) scale(415.377 417.775)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.78125,
    stopColor: "#252525"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlfredoIcon);
export default __webpack_public_path__ + "static/media/alfredo-icon.e8255c84cb624d25ca0bdd9048abc107.svg";
export { ForwardRef as ReactComponent };